import { render } from "./AISettingsAfterPlay.vue?vue&type=template&id=5ddabdeb&scoped=true"
import script from "./AISettingsAfterPlay.vue?vue&type=script&lang=js"
export * from "./AISettingsAfterPlay.vue?vue&type=script&lang=js"

import "./AISettingsAfterPlay.vue?vue&type=style&index=0&id=5ddabdeb&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddabdeb"]])

export default __exports__